"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = _default;

function _default(x, y) {
  if (x === y) {
    return true;
  }

  var xKeys = Object.keys(x);
  var yKeys = Object.keys(y);
  return xKeys.length === yKeys.length && xKeys.every(function (key) {
    return yKeys.includes(key) && x[key] === y[key];
  });
}